import React from "react";
import { useSnapshot } from "valtio";
import classnames from "classnames";
import { useTranslation } from "react-i18next/";
import { mutate } from "swr";
import { CheckboxIcon, VerticalDotsIcon } from "@aureskonnect/react-ui";
import { toast } from "react-toastify";

import ErrorToast from "@components/Common/ErrorTost";

import store from "../store";
import { store as posEditor } from "../../../../components/VerticalLayout/store";
import { ConfirmationArchive } from "../ConfirmationArchive";

export function ActionColumn({
    setIsHistoryModalOpened,
    isHistoryModalOpened,
    selectedRows,
    setDataIsUpdated,
    setIsPosEditorArchived,
    isPosEditorArchived,
    setLimit,
}: any) {
    const { t } = useTranslation();
    const {
        numberActiveMultiShop,
        numberArchiveMultiShop,
        archivedPosEditorFranchise,
        shopsPosEditorData,
        modify,
    } = useSnapshot(store);
    const { franchiseID, userID, operatorID } = useSnapshot(posEditor);

    const [error, setError] = React.useState(false);
    const [isArchiveModalOpened, setIsArchiveModalOpened] = React.useState<
        boolean
    >(false);
    const uuidUser = localStorage.getItem("uuidUser");

    function archivePosEditorFranchise() {
        let idsAssociated: any = [];
        if (
            archivedPosEditorFranchise.othersData.archivedFranchise.data !==
            undefined
        ) {
            archivedPosEditorFranchise.othersData.archivedFranchise.data.forEach(
                (element: any) => {
                    idsAssociated.push(element.Id);
                }
            );
        }
        idsAssociated = [...new Set(idsAssociated)];
        return idsAssociated;
    }
    const getArrayOfRows = () => {
        let arrayOfRows: any[] = [];
        let ids: any[] = [];

        selectedRows.forEach(async (el: any) => {
            if (
                el[t("Shop")] === undefined &&
                ids.indexOf(`${el.shopId}${el.Id}`) === -1
            ) {
                arrayOfRows.push(el);
                ids.push(`${el.shopId}${el.Id}`);
            }
        });
        arrayOfRows = [...new Set(arrayOfRows)];
        return arrayOfRows;
    };
    let arrayOfRows = getArrayOfRows();

    function shopsIdArchivePosEditor(e: any) {
        let idsAssociated: any = [];
        let shopSelectedRows: any[] = [];
        selectedRows.forEach((el: any) => {
            if (el.shopId === e.shopId) {
                shopSelectedRows.push(el.shopId);
            }
        });

        if (shopsPosEditorData.othersData.allPosEditor.data !== undefined) {
            shopsPosEditorData.othersData.allPosEditor.data.forEach(
                (element: any) => {
                    if (
                        element.subRows !== undefined &&
                        element.subRows.length === 0 &&
                        ((element.archivedPosEditor !== undefined &&
                            element.archivedPosEditor.length === 1) ||
                            (selectedRows.subRows === undefined &&
                                shopSelectedRows.length === 1))
                    ) {
                        element.archivedPosEditor.forEach((el: any) => {
                            if (el.Id === e.Id && el.shopId === e.shopId)
                                idsAssociated.push(el.shopId);
                        });
                    }
                }
            );
        }

        idsAssociated = [...new Set(idsAssociated)];
        return idsAssociated;
    }
    async function activePosEditor() {
        toast.dismiss();
        let localData: any = [];
        let isNotEmpty: boolean = false;
        let isEmpty: boolean = false;
        let arrayOfRows = getArrayOfRows();
        arrayOfRows.forEach(async (el: any) => {
            let shopsIdArchived = shopsIdArchivePosEditor(el);
            let dataPosEditor = {
                userId: userID,
                shopId: shopsIdArchived,
                franchiseId: franchiseID,
                operatorId: operatorID,
                uuidUser: uuidUser,
                isShop: false,
                data: {
                    [el.Id]: {
                        posEditor: el[t("Pos Editor")],
                        note: el[t("Remark")],
                        codeComment: el["codeComment"],
                        isActive: false,
                        isArchived: false,
                        shopId: el.shopId,
                        user: el.user,
                        versionServer: el.versionServer,
                        keyAuthentication: el.keyAuthentication,
                        apiEmail: el.apiEmail,
                        port: el.port,
                        server: el.server,
                        apiServer: el.apiServer,
                        setupId: el.setupId,
                        apiPassword: el.apiPassword,
                        modeOfSaleEmpId: el.modeOfSaleEmpId,
                        modeOfSaleLivId: el.modeOfSaleLivId,
                        modeOfSaleSPId: el.modeOfSaleSPId,
                        divisionPriceItems: el.divisionPriceItems,
                        divisionPriceOptions: el.divisionPriceOptions,
                        divisionTax: el.divisionTax,
                        layoutLabel: el.layoutLabel,
                        apiWebhook: el.apiWebhook,
                        happyHour: el?.happyHour,
                        happyHourState: el?.happyHourState,
                        tcposStoreId: el?.tcposStoreId,
                        tcposWebhookPort: el?.tcposWebhookPort,
                        tcposWebhookIPAddess: el?.tcposWebhookIPAddess,
                        tcposFranchiseSchema: el?.tcposFranchiseSchema,
                        tcposPaymentCash: el?.tcposPaymentCash,
                        tcposPaymentCreditCard: el?.tcposPaymentCreditCard,
                        tcposSetupDisk: el?.tcposSetupDisk,
                        tcposCodeCountry: el?.tcposCodeCountry,
                        tcposLangue: el?.tcposLangue,
                        tcposApiPort: el?.tcposApiPort,
                        tcposPartnerApiUrl: el?.tcposPartnerApiUrl,
                        tcposIp: el?.tcposIp,
                        tcposConnectionCheckTime: el?.tcposConnectionCheckTime,
                        tcposDeletingDataSate: el?.tcposDeletingDataSate,
                        codeRetryTable: el?.codeRetryTable,
                        maxRetry: el?.maxRetry,
                        retryDelai: el?.retryDelai,
                        checkStock: el?.checkStock,
                        orderValidationPreCheck: el?.orderValidationPreCheck,
                        timeoutAPI: el?.timeoutAPI,
                        automaticProductionLevel: el?.automaticProductionLevel,
                        tcposCorrTakeawayDisplayName:
                            el?.tcposCorrTakeawayDisplayName,
                        tcposCorrTakeawayID: el?.tcposCorrTakeawayID,
                        tcposCorrOnSiteDisplayName:
                            el?.tcposCorrOnSiteDisplayName,
                        tcposCorrOnSiteID: el?.tcposCorrOnSiteID,
                    },
                },
            };
            if (dataPosEditor.shopId.length !== 0) {
                isNotEmpty = true;
            } else {
                isEmpty = true;
            }

            const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/general/posEditor`;
            localData.push(
                fetch(apiUrlAdd, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(dataPosEditor),
                }).then((response) => response.json())
            );
        });

        try {
            mutate(
                `${process.env.REACT_APP_API_V2_URL}/settings/general/posEditor`,
                await Promise.all(localData).then((result) => {
                    setLimit(2);
                    if (error === false && isNotEmpty) {
                        toast.success(
                            `${t(
                                "The Pos Editor has been successfully unarchive"
                            )!}`,
                            {
                                position: toast.POSITION.TOP_CENTER,
                                theme: "colored",
                                icon: (
                                    <CheckboxIcon
                                        height={25}
                                        width={25}
                                        fill="white"
                                    />
                                ),
                            }
                        );

                        setDataIsUpdated!(true);
                    }
                    if (isEmpty) {
                        ErrorToast(
                            t(
                                "Attention,a shop cannot have more than one Pos Editor"
                            )
                        );

                        setDataIsUpdated!(true);
                    }
                })
            );
        } catch (e) {
            toast.error(`${t("There's an error")!}`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            setError(true);
        }
    }

    return (
        <React.Fragment>
            <div>
                <div className="dropdown">
                    <VerticalDotsIcon
                        id="dropdownMenuButton1"
                        className="cmn_drp_BTmenu"
                        data-bs-toggle="dropdown"
                        style={{ cursor: "pointer" }}
                        height={25}
                        width={25}
                        fill="black"
                    />
                    <div
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                    >
                        <div
                            className="dropdown-item pl-1"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                setIsPosEditorArchived(false);
                            }}
                        >
                            <span className="ml-2 cmn_btn_BTlistActivated">
                                {t("Pos Editor Enabled(s)")} (
                                {numberActiveMultiShop})
                            </span>
                        </div>
                        <div
                            className="dropdown-item pl-1 d-none"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                setIsPosEditorArchived(true);
                            }}
                        >
                            <span className="ml-2 cmn_btn_BTlistArchived">
                                {t("Archived Pos Editor(s)")}(
                                {numberArchiveMultiShop})
                            </span>
                        </div>
                        <div
                            style={{ cursor: "pointer" }}
                            className={`${classnames(
                                " dropdown-item pl-1 pointer__clz",
                                {
                                    "not-allowed-icon__clz":
                                        selectedRows.length === 0 ||
                                        arrayOfRows.length === 0,
                                }
                            )}`}
                            onClick={() => {
                                setIsHistoryModalOpened(!isHistoryModalOpened);
                            }}
                        >
                            <span className="ml-2 cmn_btn_BThistory">
                                {t("Historical")}
                            </span>
                        </div>
                        {modify === true ? (
                            <>
                                <div
                                    style={{ cursor: "pointer" }}
                                    className={` ${classnames(
                                        " dropdown-item pl-1 pointer__clz d-none",
                                        {
                                            "not-allowed-icon__clz":
                                                selectedRows.length === 0 ||
                                                (isPosEditorArchived &&
                                                    getArrayOfRows().some(
                                                        (element: any) =>
                                                            archivePosEditorFranchise().includes(
                                                                element.Id
                                                            )
                                                    )) ||
                                                arrayOfRows.length === 0 ||
                                                getArrayOfRows().every(
                                                    (element: any) =>
                                                        element[t("State")] ===
                                                        true
                                                ),
                                        }
                                    )}`}
                                    onClick={() => {
                                        isPosEditorArchived
                                            ? activePosEditor()
                                            : setIsArchiveModalOpened(true);
                                    }}
                                >
                                    <span className="ml-2 cmn_btn_BTarchived cmn_btn_BTunarchive">
                                        {isPosEditorArchived
                                            ? t("unarchive")
                                            : t("archive")}
                                    </span>
                                </div>
                            </>
                        ) : null}
                    </div>
                </div>
            </div>
            {setIsArchiveModalOpened ? (
                <ConfirmationArchive
                    isModalOpened={isArchiveModalOpened}
                    setIsModalOpened={setIsArchiveModalOpened}
                    setDataIsUpdated={setDataIsUpdated}
                    selectedRows={selectedRows}
                    setLimit={setLimit}
                />
            ) : null}
        </React.Fragment>
    );
}
